import { useRecoilValue } from "recoil"
import { Flex } from "@chakra-ui/react"
import { ImExit } from "react-icons/im"
import styled from "@emotion/styled"

import useHandleLeaveMeeting from "./useHandleLeaveMeeting"
import { brandingSelector } from "../../../recoil/atoms/room"
import type { RoomBranding } from "../../../recoil/atoms/room/types"
import { BackIconButton } from "src/components/views/home/HomeBackIcon"

interface StyledProps {
  roomStyles?: RoomBranding
}

const ExitIcon = styled(ImExit)<StyledProps>`
  margin-left: 2.5px;
  margin-top: 1.5px;
  color: ${({ roomStyles }) =>
    roomStyles?.joinPageButtonTextColor ?? "#FFFFFF"};
`

type LeaveMeetingButtonProps = {
  color: string
  backgroundColor: string
  top?: `${number}px`
  showBackIcon?: boolean
}

const LeaveMeetingButton = ({
  color,
  backgroundColor,
  top = "0px",
  showBackIcon = false
}: LeaveMeetingButtonProps) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const handleMeetingLeave = useHandleLeaveMeeting()

  if (showBackIcon) {
    return (
      <BackIconButton
        padding={"5px"}
        onClick={handleMeetingLeave}
        onTouchStart={handleMeetingLeave}
      />
    )
  }

  return (
    <Flex
      pos="relative"
      color={color ?? "white"}
      top={top}
      backgroundColor={backgroundColor ?? "#1AC541"}
      onClick={handleMeetingLeave}
      onTouchStart={handleMeetingLeave}
      height="1.9rem"
      width="1.9rem"
      borderRadius="0.375rem"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
    >
      <ExitIcon size="1.35em" roomStyles={roomStyles} color={color} />
    </Flex>
  )
}

export default LeaveMeetingButton
